import { AbstractControl, FormArray } from '@angular/forms';

import { MaritalStatus } from 'shared/openapi/models';

export type When = (
	control: AbstractControl,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	form: any,
	currentFieldName: string,
	...parameters: string[]
) => boolean;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getFormValue(currentFieldName: string, fieldName: string, control: AbstractControl, form?: any) {
	if (fieldName) {
		// If the field name contains a dot, it represents a nested path.
		// like customers[].personalData.maritalStatus
		if (fieldName.includes('.')) {
			// Find the last control in the hierarchy that is not a FormArray.
			// In this example: personalData
			const formArrayControl = findControlBeforeFormArray(control);
			const fields = fieldName.split('.');
			// Build the path excluding the first item which is the FormArray.
			// in this example: the customers[]
			const path = fields.slice(1, fields.length).join('.');
			if (formArrayControl) {
				// If a control before a FormArray was found, apply the path to this control.
				// in this example: personalData.maritalStatus
				return formArrayControl.get(path)?.value;
			} else {
				// If there is no FormArray in the path, apply the path directly to the form.
				// example: familyStatus.previouslyAppliedForCsok
				return form.get(fieldName).value;
			}
		} else {
			// If the field name doesn't contain a dot, get the value directly from the parent control.
			// for example mailingAndPermanentAddressEquals
			return control.parent?.get(fieldName)?.value;
		}
	}
	// If fieldName is not provided, use the currentFieldName.
	// Example: customers.incomeAndEducation.numberOfDegrees
	const fields = currentFieldName.split('.');
	const path = fields.slice(1, fields.length).join('.');
	const formArrayControl = findControlBeforeFormArray(control);
	if (formArrayControl) {
		return formArrayControl.get(path)?.value;
	}
}

function findControlBeforeFormArray(control: AbstractControl): AbstractControl | null {
	let currentControl: AbstractControl | null = control;
	let lastControlBeforeArray: AbstractControl | null = null;

	while (currentControl) {
		if (currentControl instanceof FormArray) {
			return lastControlBeforeArray;
		}
		lastControlBeforeArray = currentControl;
		currentControl = currentControl.parent;
	}

	return null;
}

export const IfHas: When = (control, form, currentFieldName, fieldName) => {
	const value = getFormValue(currentFieldName, fieldName, control, form);

	return !!value;
};

export const IfHasAny: When = (control, form, currentFieldName, ...params) => {
	return params.some((fieldName) => {
		const value = getFormValue(currentFieldName, fieldName, control, form);

		return !!value;
	});
};

export const IfNotSingle: When = (control, form, currentFieldName, fieldName) => {
	const value = getFormValue(currentFieldName, fieldName, control, form);

	return value === MaritalStatus.Married.toString() || value === MaritalStatus.CivilPartnership.toString();
};

export const IfMarried: When = (control, form) => {
	const value = form.controls.customers.controls[0].controls.personalData.controls.maritalStatus.value;

	return value === MaritalStatus.Married.toString();
};

// works differently at backend. at frontend, we show all language exams fields, when the user chooses yes from radio group.
export const ShowLanguageExams: When = () => {
	return true;
};

export const ShowNumberOfDegrees: When = (control, form, currentFieldName, ...params) => {
	const acceptedValues = params.slice(1);
	const value = getFormValue(currentFieldName, params[0], control, form);

	return acceptedValues.includes(value?.toString());
};

// todo: test
export const IfFieldIs: When = (control, form, currentFieldName, ...params) => {
	const acceptedValues = params.slice(1);

	const value = getFormValue(currentFieldName, params[0], control);

	// if (acceptedValues === null) {
	// 	return value === null;
	// }
	if (value === null || value === undefined) {
		return false;
	}

	return acceptedValues.includes(value.toString());
};
